import { matchesContactKeyword, matchesPreparedContactKeyword, normalizeSearchKeyword } from './contactSearchMatcher.js';

export const CHAT_TYPE_FILTERS = Object.freeze(['ALL', 'PRIVATE', 'GROUP']);
export const READ_STATE_FILTERS = Object.freeze(['ALL', 'READ', 'UNREAD']);

function normalizeSearchText(searchText) {
	return typeof searchText === 'string' ? searchText.trim() : '';
}

function normalizeFilterValue(value, candidates, fallback = 'ALL') {
	return candidates.includes(value) ? value : fallback;
}

export function matchesChatType(chat, chatType = 'ALL') {
	const normalizedChatType = normalizeFilterValue(chatType, CHAT_TYPE_FILTERS);
	if (normalizedChatType === 'ALL') {
		return true;
	}
	return chat && chat.type === normalizedChatType;
}

export function matchesReadState(chat, readState = 'ALL') {
	const normalizedReadState = normalizeFilterValue(readState, READ_STATE_FILTERS);
	if (normalizedReadState === 'ALL') {
		return true;
	}
	const unreadCount = Number(chat && chat.unreadCount) || 0;
	return normalizedReadState === 'UNREAD' ? unreadCount > 0 : unreadCount === 0;
}

export function matchesSearchText(chat, searchText = '') {
	return matchesContactKeyword(chat, normalizeSearchText(searchText));
}

export function matchesChatSearchText(chat, searchText = '', options = {}) {
	const normalizedSearchText = normalizeSearchKeyword(searchText);
	if (!normalizedSearchText) {
		return true;
	}
	if (typeof options.getSearchText === 'function') {
		return matchesPreparedContactKeyword(options.getSearchText(chat), normalizedSearchText);
	}
	return matchesContactKeyword(chat, normalizedSearchText);
}

export function filterChats(chats = [], options = {}) {
	const source = Array.isArray(chats) ? chats : [];
	const { searchText = '', chatType = 'ALL', readState = 'ALL' } = options || {};
	const normalizedSearchText = normalizeSearchKeyword(searchText);
	return source.filter((chat) => (
		chat && !chat.delete
		&& matchesChatType(chat, chatType)
		&& matchesReadState(chat, readState)
		&& matchesChatSearchText(chat, normalizedSearchText, options)
	));
}
